import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { produce } from 'immer'
import { fetchEditlogs, selectCategories } from 'features/editlog/editlogSlice'
import CheckBox from 'components/form/CheckBox'
import { isNullOrUndefined } from 'utils'
import NoneAnchor from 'components/NoneAnchor'
import useOutsideClick from '../../../utils/hooks/useOutsideClick'

const EDIT_OPTIONS = [
  {
    id: 'CREATE_DELETE',
    name: '등록/삭제',
  },
  {
    id: 'ON_OFF',
    name: 'ON/OFF',
  },
  {
    id: 'PAUSE',
    name: '광고중지/재개',
  },
  {
    id: 'BIDDING_AMOUNT',
    name: '입찰가',
  },
  {
    id: 'BUDGET',
    name: '예산',
  },
  {
    id: 'STRATEGY',
    name: '시간, 매체 등 전략',
  },
  {
    id: 'REQUEST_REVIEW_AGAIN',
    name: '재심사요청',
  },
  {
    id: 'ADMIN_PAUSE_ENABLE',
    name: '관리자정지/해제',
  },
  {
    id: 'BIZ_WALLET',
    name: '비즈월렛',
  },
]

const REVIEW_OPTIONS = [
  {
    id: 'REVIEW_APPROVED',
    name: '심사 승인',
  },
  {
    id: 'REVIEW_REJECTED',
    name: '심사 보류',
  },
]

const EDIT_ID_LIST = EDIT_OPTIONS.map(opt => opt.id)
const REVIEW_ID_LIST = REVIEW_OPTIONS.map(opt => opt.id)

const CategoryFilter = () => {
  const dispatch = useDispatch()
  const [isFilterOpen, setFilterOpen] = useState(false)
  const [formValues, setFormValues] = useState({
    CREATE_DELETE: true,
    ON_OFF: true,
    PAUSE: true,
    BIDDING_AMOUNT: true,
    BUDGET: true,
    STRATEGY: true,
    REVIEW_APPROVED: true,
    REVIEW_REJECTED: true,
    REQUEST_REVIEW_AGAIN: true,
    ADMIN_PAUSE_ENABLE: true,
    BIZ_WALLET: true,
  })

  const { categories } = useSelector(state => state.editlog.formValues)

  // '적용'을 클릭하지 않고  카테고리 팝업을 닫으면 롤백
  useEffect(() => {
    if (!isFilterOpen) {
      setFormValues(
        produce(draft => {
          ;[...EDIT_ID_LIST, ...REVIEW_ID_LIST].forEach(item => {
            draft[item] = isNullOrUndefined(categories[item])
              ? true // Initial value is undefined
              : categories[item]
          })
        })
      )
    }
  }, [categories, isFilterOpen])

  const {
    CREATE_DELETE,
    ON_OFF,
    PAUSE,
    BIDDING_AMOUNT,
    BUDGET,
    STRATEGY,
    REVIEW_APPROVED,
    REVIEW_REJECTED,
    REQUEST_REVIEW_AGAIN,
    ADMIN_PAUSE_ENABLE,
  } = formValues
  const isEditAll = () =>
    CREATE_DELETE &&
    ON_OFF &&
    PAUSE &&
    BIDDING_AMOUNT &&
    BUDGET &&
    STRATEGY &&
    REQUEST_REVIEW_AGAIN &&
    ADMIN_PAUSE_ENABLE
  const isReviewAll = () => REVIEW_APPROVED && REVIEW_REJECTED

  const handleCheckboxChange = event => {
    const { target } = event
    const { value, checked } = target
    setFormValues(
      produce(draft => {
        if (value === 'all') {
          ;[...EDIT_ID_LIST, ...REVIEW_ID_LIST].forEach(item => {
            draft[item] = checked
          })
        } else if (value === 'editAll') {
          ;[...EDIT_ID_LIST].forEach(item => {
            draft[item] = checked
          })
        } else if (value === 'reviewAll') {
          ;[...REVIEW_ID_LIST].forEach(item => {
            draft[item] = checked
          })
        } else {
          draft[value] = checked
        }
      })
    )
  }
  const ref = useOutsideClick(() => setFilterOpen(false))
  return (
    <div ref={ref} className="single_wrap">
      <div
        className={classNames('opt_select opt_filter', {
          opt_open: isFilterOpen,
          in_active: false,
        })}>
        <div className="screen_out">데이터종류 선택상자</div>
        <span className="screen_out">선택내용 : </span>
        <NoneAnchor
          className="link_selected"
          onClick={() => {
            setFilterOpen(!isFilterOpen)
          }}>
          필터
        </NoneAnchor>
        <span className="ico_arr" />
        <div className="screen_out">선택옵션</div>
        <div className="opt_list">
          <ul className="list_opt">
            <li>
              <span className="box_checkinp">
                <CheckBox
                  label="전체"
                  value="all"
                  onChange={handleCheckboxChange}
                  checked={isEditAll() && isReviewAll()}
                />
              </span>
            </li>
            <li>
              <span className="box_checkinp">
                <CheckBox
                  label="변경이력"
                  value="editAll"
                  onChange={handleCheckboxChange}
                  checked={isEditAll()}
                />
              </span>
              <ul className="list_opt">
                {EDIT_OPTIONS.map(child => (
                  <li key={child.id}>
                    <CheckBox
                      label={child.name}
                      value={child.id}
                      onChange={handleCheckboxChange}
                      checked={formValues[child.id]}
                    />
                  </li>
                ))}
              </ul>
            </li>
            <li>
              <span className="box_checkinp">
                <CheckBox
                  label="심사이력 "
                  value="reviewAll"
                  onChange={handleCheckboxChange}
                  checked={isReviewAll()}
                />
              </span>
              <ul className="list_opt">
                {REVIEW_OPTIONS.map(child => (
                  <li key={child.id}>
                    <CheckBox
                      label={child.name}
                      value={child.id}
                      onChange={handleCheckboxChange}
                      checked={formValues[child.id]}
                    />
                  </li>
                ))}
              </ul>
            </li>
          </ul>
          <div className="wrap_btn">
            <NoneAnchor
              className={classNames('btn_gm gm_line', {
                in_active: Object.values(formValues).every(v => !v),
              })}
              onClick={() => {
                dispatch(selectCategories(formValues))
                dispatch(fetchEditlogs())
                setFilterOpen(false)
              }}>
              <span className="inner_g">적용</span>
            </NoneAnchor>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CategoryFilter

CategoryFilter.propTypes = {
  onApplyFilter: PropTypes.func,
}
